import { MINIMUM_BROWSER_VERSIONS } from '../config/browser-versions';

type BrowserName = keyof typeof MINIMUM_BROWSER_VERSIONS;

interface BrowserInfo {
  name: string;
  version: number;
}

interface BrowserCheckResult {
  supported: boolean;
  browser: string;
  version: number;
  minVersion?: number;
}

function detectBrowser(): BrowserInfo {
  const ua = navigator.userAgent;

  const edgeMatch = ua.match(/Edg\/(\d+)/);
  if (edgeMatch) {
    return { name: 'edge', version: parseInt(edgeMatch[1]) };
  }

  const chromeMatch = ua.match(/Chrome\/(\d+)/);
  if (chromeMatch && !/Edg\//.test(ua)) {
    return { name: 'chrome', version: parseInt(chromeMatch[1]) };
  }

  const firefoxMatch = ua.match(/Firefox\/(\d+)/);
  if (firefoxMatch) {
    return { name: 'firefox', version: parseInt(firefoxMatch[1]) };
  }

  const safariMatch = ua.match(/Version\/(\d+).*Safari/);
  if (safariMatch && !/Chrome/.test(ua)) {
    return { name: 'safari', version: parseInt(safariMatch[1]) };
  }

  return { name: 'unknown', version: 0 };
}

export function checkBrowserVersion(): BrowserCheckResult {
  const browser = detectBrowser();
  const minVersion = MINIMUM_BROWSER_VERSIONS[browser.name as BrowserName];

  if (!minVersion) {
    return {
      supported: false,
      browser: browser.name,
      version: browser.version
    };
  }

  const supported = browser.version >= minVersion;
  return {
    supported,
    browser: browser.name,
    version: browser.version,
    minVersion
  };
}
